import { TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, WIDGET_MEDIA_BORDER_RADIUS, WIDGET_SPACE, DEFAULT_LINK_ID } from '../../utils/constants/Constants.js';
import { ConditionalWrapper } from '../../HOCs/ConditionalWrapper/index.js';
import { GenericContainer } from '../components/GenericContainer.js';
import React from 'react';
import { styled } from '@mui/material';

var HeaderContainer = styled(GenericContainer, {
    shouldForwardProp: function (prop) { return !['fullWidth', 'horizontalPadding'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var _c = _a.horizontalPadding, horizontalPadding = _c === void 0 ? WIDGET_SPACE : _c, theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: horizontalPadding,
            paddingBottom: horizontalPadding,
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var Container = styled('div', {
    shouldForwardProp: function (prop) { return !['fullWidth'].includes(prop.toString()); },
})(function (_a) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b;
    return ({
        maxWidth: fullWidth ? '100%' : DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        width: '100%',
        img: {
            borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
            maxWidth: '100%',
        },
    });
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var ShortWideBanner = function (_a) {
    var image = _a.image, link = _a.link, fullWidth = _a.fullWidth, horizontalPadding = _a.horizontalPadding, LinkComponent = _a.LinkComponent;
    return (React.createElement(HeaderContainer, { fullWidth: fullWidth, horizontalPadding: horizontalPadding },
        React.createElement(Container, { fullWidth: fullWidth },
            React.createElement(ConditionalWrapper, { condition: !!(link === null || link === void 0 ? void 0 : link.id) && !link.id.startsWith(DEFAULT_LINK_ID), wrapper: function (children) { return React.createElement(LinkComponent, { to: (link === null || link === void 0 ? void 0 : link.id) || '/' }, children); } },
                React.createElement("img", { loading: "lazy", src: image, style: { width: '100%' }, alt: "ctmg" })))));
};

export { ShortWideBanner };
//# sourceMappingURL=index.js.map
